import template from './ps-number-input.html';
import './ps-number-input.css';

class PSNumberInput {
	constructor(params, rootElement, componentInfo) {
		this.params = params;
		this.rootElement = rootElement;

		console.log('rootElement',rootElement);

		this.disabled = ko_helper.safe_observable(params.disabled, false);
		this.inputClasses = ko_helper.safe_observable(params.inputClasses, 'ps-input');
		
		this.value = ko_helper.safe_observable(params.value, 0);
		this.format = ko_helper.safe_observable(params.format, '0,0.00');
		this.locale = ko_helper.safe_observable(params.locale, null);

		this.input = ko.observable(numeral(this.value()).format(this.format()));

		let oldi = null;
		let oldv = null;
		this.input.subscribe((ni) => {
			if (oldi === ni)
				return;
			let n = numeral(ni);
			oldv = n.value();
			this.value(oldv);
			oldi = n.format(this.format());
			this.input(oldi);
		});
		this.value.subscribe((nv) => {
			if (oldv === nv)
				return;
			let n = numeral(nv);
			oldi = n.format(this.format());
			this.input(oldi);
			oldv = n.value();
			this.value(oldv);
		});
	}

}

export default {
	name: 'ps-number-input',
	viewModel: PSNumberInput,
	provider: 'ko',
	template: template
};
